import { Lightbulb } from 'lucide-react';
import type { UnbilledCloud } from '@lizrd/contracts';

/**
 * Callout shown wherever a BILLED cost total is displayed: names the connected cloud
 * accounts whose billed cost isn't in the total yet — their billing feed isn't set up,
 * is still in its grace period, or is warming up. We never substitute an estimate for
 * billed cost; we flag the gap so the total stays a pure billed figure and the customer
 * knows to wire the missing feed.
 */
export function UnbilledCloudsNote({
  clouds,
  className = '',
}: {
  clouds: UnbilledCloud[];
  className?: string;
}) {
  if (clouds.length === 0) return null;
  const n = clouds.length;
  const names = clouds.map((c) => c.displayName).join(', ');
  return (
    <div
      className={`rounded-sm border border-hairline bg-surface-2/40 px-3 py-2 text-xs text-muted ${className}`}
    >
      <Lightbulb aria-hidden className="mr-1 inline h-4 w-4 align-text-bottom text-iris" />
      <span className="font-semibold text-bone">{n}</span>{' '}
      {n === 1 ? 'integration is' : 'integrations are'} missing billed cost and{' '}
      {n === 1 ? "isn't" : "aren't"} in this total <span className="text-haze">({names})</span>. Set
      up {n === 1 ? 'its' : 'their'} billing feed (for GCP, a BigQuery billing export) to include{' '}
      {n === 1 ? 'it' : 'them'}.
    </div>
  );
}
